var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],staticClass:"mt-2"},[_vm._l((_vm.sets),function(row,index){return [_c('span',{staticClass:"d-block"},[_vm._v("\n            "+_vm._s(row.quantity)+" - "+_vm._s(row.description)+"\n        ")])]})],2)}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7525b548","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/items/PackItemDescription.vue
// module id = +9vH
// module chunks = 0